export const agentMainNavigation = (userRole: string) => {

  if (userRole === 'Admin') {
    return [
      { path: '/agent/clients', label: 'Clients' },
      { path: '/agent/onboarding', label: 'Onboarding' },
      { path: '/agent/global-map', label: 'Global Map' },
      //{ path: '/agent/companies', label: 'Companies' },
      { path: '/agent/burnin', label: 'Burn In' },
      { path: '/agent/uptime', label: 'Uptime' },
    ];
  }

  if (userRole === 'Technical-Agent') {
    return [
      { path: '/agent/clients', label: 'Clients' },
      { path: '/agent/onboarding', label: 'Onboarding' },
      //{ path: '/agent/companies', label: 'Companies' },
      { path: '/agent/uptime', label: 'Uptime' },
    ];
  }

  if (userRole === 'Company-Admin') {
    return [
      { path: '/agent/clients', label: 'Users' },
      //{ path: '/agent/companies', label: 'Companies' },
      { path: '/agent/uptime', label: 'Uptime' },
    ];
  }

  return [
    { path: '/agent/clients', label: 'Clients' },
    { path: '/agent/onboarding', label: 'Onboarding' }
  ];
}

export const agentClientsFilters = [
  { path: '/agent/clients/all', label: 'All', searchText: '' },
  // { path: '/agent/clients/deactivated', label: 'Deactivated', searchText: '' },
];

export const  agentOnboaringFilters = [
  {
    path: '/agent/onboarding/outstanding-details',
    label: 'All',
    searchText: ''
  },
  /*
  {
    path: '/agent/onboarding/outstanding-details',
    label: 'Outstanding details',
    searchText: ''
  },
  {
    path: '/agent/onboarding/booking-pending',
    label: 'Booking pending',
    searchText: ''
  },
  {
    path: '/agent/onboarding/scheduled',
    label: 'Scheduled',
    searchText: ''
  },
  */
];

export const agentCompaniesFilters = [
  { path: '/agent/companies/all', label: 'All', searchText: '' },
];

export const agentBurnInFilters = [
  { path: '/agent/burnin/all', label: 'All', searchText: '' },
];

export const agentInstallationFilters = [
  { path: '/agent/installations/all', label: 'All', searchText: '' },
];

export const agentMgtDevicesFilters = [
  { path: '/agent/mgt-devices/all', label: 'All', searchText: '' },
];

export const agentUptimeFilters = [
  { path: '/agent/uptime/all', label: 'All', searchText: '' },
];